if (!customElements.get('tiburn-video-hero')) {
  customElements.define('tiburn-video-hero', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const mobile = matchMedia('(max-width: 767px)');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const slot = this.querySelector('.tvh__video-slot');
      const button = this.querySelector('.tvh__toggle');
      let video;
      let userPaused = reduce.matches;
      let visible = true;
      const sync = () => {
        const paused = !video || video.paused;
        button.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
        button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      };
      const play = () => {
        if (video && !userPaused && visible && !document.hidden) video.play().catch(sync);
      };
      const mount = () => {
        video?.pause();
        const template = this.querySelector(mobile.matches ? '[data-mobile]' : '[data-desktop]');
        slot.replaceChildren();
        if (!template) { button.hidden = true; return; }
        slot.append(template.content.cloneNode(true));
        video = slot.querySelector('video');
        video.muted = true;
        video.playsInline = true;
        video.removeAttribute('autoplay');
        video.addEventListener('play', sync, options);
        video.addEventListener('pause', sync, options);
        video.addEventListener('error', () => { video.hidden = true; button.hidden = true; }, options);
        button.hidden = false;
        sync();
        play();
      };
      button.addEventListener('click', () => {
        if (!video) return;
        userPaused = !video.paused;
        if (userPaused) video.pause(); else video.play().catch(sync);
      }, options);
      mobile.addEventListener('change', mount, options);
      reduce.addEventListener('change', () => { userPaused = reduce.matches; if (userPaused) video?.pause(); else play(); }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video?.pause(); else play(); }, options);
      const observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        if (!visible) video?.pause(); else play();
      });
      observer.observe(this);
      this.cleanup = () => { controller.abort(); observer.disconnect(); video?.pause(); };
      mount();
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
